

import Vue from 'vue'
import FastClick from 'fastclick'

import App from './App'

import router from './router'
import { store } from './store'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'


FastClick.attach(document.body)

import VueTouch from 'vue-touch'
Vue.use(VueTouch, {name: 'v-touch'})

Vue.use(LoadingPlugin)

Vue.config.productionTip = false

Vue.prototype.config = {
FILE_SERVER: process.env.FILE_SERVER
}

Vue.filter('filePathFilter', function (value) {
return process.env.FILE_SERVER + value
})
Vue.filter('space2str', function (value) {
return value.replace(/ /g,"&nbsp");
})
Vue.prototype.space2str=function(value){
return value.replace(/ /g,"&nbsp");

}

router.beforeEach((to, from, next) => {
if(to.meta){
document.title = to.meta.title||'学员端'
}
next()
})

/* eslint-disable no-new */
new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js